<template>
  <div>
    <div class="mb-4" @click="expended = !expended">
      <a href="javascript:void(0)" class="flex items-center group py-3" :class="expended ? 'text-white' : 'text-gray-400 hover:text-white'">
        <icon :name="icon" class="w-4 h-4 mr-2 fill-current" />
        <span class="flex w-full">
          <span class="w-full">{{ label }}</span>
          <icon name="cheveron-up-down" class="w-4 h-4 mr-2 fill-current" />
        </span>
      </a>
    </div>
    <transition name="slide-fade">
      <div v-if="expended" class="ml-5">
        <slot></slot>
      </div>
    </transition>
  </div>
</template>
<script>
import Icon from "../Icon.vue";

export default {
  name: "CollapsableMenuItem",

  props: {
    label: {
      type: String,
      default: "Archives"
    },
    icon: {
      type: String,
      default: "plus"
    },
    active: Boolean,
  },
  components: {Icon},

  data() {
    return {
      expended: this.active || false,
    }
  },

  watch: {
    active: {
      handler(v) {
        this.expended = v;
      }
    }
  },

  mounted() {
    this.expended = this.active
  },
}
</script>

<style scoped>

.slide-fade-enter-active {
  transition: all .2s ease-in;
}
.slide-fade-leave-active {
  transition: all .1s ease-out;
}
.slide-fade-enter, .slide-fade-leave-to {
  transform: translateY(-10px);
  opacity: 0;
}
</style>
